import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { ioDispatcher3b9pa3x0duop as ioDispatcher } from '../../../../../ktor-ktor-io/io/ktor/utils/io/IODispatcher.web.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SilentSupervisorlzoikirj0zeo as SilentSupervisor } from '../../../../../ktor-ktor-utils/io/ktor/util/CoroutinesUtils.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Key_instancepi2bbb0csu5f as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_supportedCapabilities36x6e2ixit204 as get_supportedCapabilities,
  install34ed8l0uhurm0 as install,
  HttpClientEngine3f41d0b7i209y as HttpClientEngine,
} from './HttpClientEngine.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v() {
  return constructCallableReference((p0) => p0.get_dispatcher_usy1bk_k$(), 1, 0, 215);
}
function HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr() {
  return constructCallableReference((p0) => p0.get_coroutineContext_115oqo_k$(), 1, 0, 216);
}
var HttpClientEngineBaseClass;
function HttpClientEngineBase() {
  if (HttpClientEngineBaseClass === VOID) {
    class $ {
      constructor(engineName) {
        this.engineName_1 = engineName;
        this.closed_1 = atomic$boolean$1(false);
        this.clientRefCount_1 = atomic$int$1(0);
        var tmp = this;
        tmp.dispatcher$delegate_1 = lazy(() => {
          var tmp0_elvis_lhs = this.get_config_c0698r_k$().dispatcher_1;
          return tmp0_elvis_lhs == null ? ioDispatcher() : tmp0_elvis_lhs;
        });
        var tmp_0 = this;
        tmp_0.coroutineContext$delegate_1 = lazy(() => SilentSupervisor().plus_s13ygv_k$(this.get_dispatcher_usy1bk_k$()).plus_s13ygv_k$(new (CoroutineName())(this.engineName_1 + '-context')));
      }
      get_dispatcher_usy1bk_k$() {
        var tmp0 = this.dispatcher$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('dispatcher', 1, tmp, HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_coroutineContext_115oqo_k$() {
        var tmp0 = this.coroutineContext$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('coroutineContext', 1, tmp, HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr(), null);
        return tmp0.get_value_j01efc_k$();
      }
      close_yn9xrc_k$() {
        if (!this.closed_1.atomicfu$compareAndSet(false, true))
          return Unit_instance;
        var tmp = this.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var requestJob = tmp_0;
        requestJob.complete_9ww6vb_k$();
      }
    }
    protoOf($).get_supportedCapabilities_gwz15x_k$ = get_supportedCapabilities;
    protoOf($).install_se0ieo_k$ = install;
    initMetadataForClass($, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine()], [1]);
    HttpClientEngineBaseClass = $;
  }
  return HttpClientEngineBaseClass;
}
var ClientEngineClosedExceptionClass;
function ClientEngineClosedException() {
  if (ClientEngineClosedExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(cause) {
        return new.target.new_io_ktor_client_engine_ClientEngineClosedException_mo8xzx_k$(cause);
      }
      static new_io_ktor_client_engine_ClientEngineClosedException_mo8xzx_k$(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$('Client already closed');
        captureStack($this, $this.$throwableCtor_4);
        $this.cause_1 = cause;
        delete $this.cause;
        return $this;
      }
      get_cause_iplhs0_k$() {
        return this.cause_1;
      }
      get cause() {
        return this.get_cause_iplhs0_k$();
      }
    }
    initMetadataForClass($, 'ClientEngineClosedException', $.new_io_ktor_client_engine_ClientEngineClosedException_mo8xzx_k$);
    ClientEngineClosedExceptionClass = $;
  }
  return ClientEngineClosedExceptionClass;
}
//region block: exports
export {
  ClientEngineClosedException as ClientEngineClosedException1qtw9cl0kd5fk,
  HttpClientEngineBase as HttpClientEngineBase2tgisnw4e4drr,
};
//endregion

//# sourceMappingURL=HttpClientEngineBase.mjs.map
